import APIKeys from '@debbie/iris/dist/components/APIKeys.js'
import React from 'react'

const API = (props: {}) => {
  return <APIKeys />
}

export default API
